/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ReviewTarfRequestRequestBody = {
    properties: {
        status: {
    type: 'number',
    isRequired: true,
},
        supervisorComment: {
    type: 'string',
    isRequired: true,
},
    },
};